(ns app.front.view.public-records.ui
  (:require [app.front.ui.content-switcher :as ui-cs]
            [core.front.carbon :as cc]
            [core.front.event :refer [<sub >evt]]))

(defn form-row [key val & [class]]
  [:div.flex-0
   (when class {:class class})
   [:div.font-bold.text-sm key]
   [:div.mt-1 val]])

(defn results-count [tr result-count in-progress?]
  [:div.flex
   [:h3.mb-0
    (tr [:dashboard-search/results])
    (when (and result-count (not in-progress?))
      (str " (" result-count ")"))]
   (when in-progress?
     (cc/loading-spinner {:with-overlay false
                          :small        true
                          :class-name   "ml-2 my-1"}))])

(defn- switcher [items current on-change val->str & {:keys [class-name]}]
  [ui-cs/content-switcher {:class     class-name
                           :items     items
                           :val->str  val->str
                           :current   current
                           :on-change on-change}])

(defn result-count+switcher
  [tr n-results in-progress? & {:keys [class-name selected-view-sub set-selected-view-evt]}]
  [:div.flex.justify-between.items-center
   {:class (or class-name "mt-8 mb-4")}
   [results-count tr n-results in-progress?]
   [:div
    [switcher [:dashboard-search/list-view
               :dashboard-search/map-view]
     (or (<sub [selected-view-sub])
         :dashboard-search/list-view)
     #(>evt [set-selected-view-evt %])
     (comp tr vector)]]])
